import { isDirectKgUnit } from "./unitLabels";
import type { CreateItemPayload, SupplierSubmissionItem } from "./types";

export function buildCreateQuotationItemPayloadFromSubmission(
  submission: SupplierSubmissionItem,
): CreateItemPayload {
  const payload: CreateItemPayload = {
    product_id: submission.product_id,
    supplier_id: submission.supplier_id,
    unit_type: submission.unit_type,
    is_offer: false,
  };

  if (isDirectKgUnit(submission.unit_type)) {
    payload.price_per_kg = submission.price_per_kg;
  } else {
    payload.price_per_box = submission.price_per_box;
  }

  if (submission.units_per_box != null) {
    payload.units_per_box = submission.units_per_box;
  }
  if (submission.kg_per_box != null) {
    payload.kg_per_box = submission.kg_per_box;
  }

  return payload;
}
